import { Container } from '@bfa/common-ui';
import React, { ReactNode } from 'react';

export const PageContainer = ({ children }: { children: ReactNode }) => (
  <Container px="0" marginBottom="2rem" width={['100%', '55.8rem']}>
    {children}
  </Container>
);

export const ContentContainer = ({ children }: { children: ReactNode }) => (
  <Container padding={['0 1.5rem', 0]} marginTop={['2rem', '3.2rem']}>
    {children}
  </Container>
);
